import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Copyright from './Copyright';
/**
 * 竹米开放平台底部
 * @returns 
 */
export function ZhumiFooter() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '25vh',
      }}
    >
      <CssBaseline />
      <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: 'auto',
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[200]
              : theme.palette.grey[800],
        }}
      >
        <Container maxWidth="sm">
          <Copyright></Copyright>
          <Typography align="center" variant='body2'>
            <a target="_blank" href="https://qm.qq.com/cgi-bin/qm/qr?k=U5T2BOXWzHzRMOk54yIBLPed8nzHsxbM&jump_from=webapi&authKey=1X2RgL8mooxTqO//oJGeX2ngfSqYCrx8kJ+CjEgFkML4dR7Hy01FoOzTq/P8uyBu">
              <img src="//pub.idqqimg.com/wpa/images/group.png" alt="竹米开放平台" title="竹米开放平台"/>
            </a>
          </Typography>
          <Typography align="center" variant='body2'>
            <Link href="https://beian.miit.gov.cn/" target="_blank" style={{textDecoration:"none"}}>粤ICP备2021070858号-1</Link>  
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}